import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class MobileTransferVehicleService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
  * Get avilable spare parts
  * @returns Observable<ApiResponse>
  */
  fetchAvailableSpareParts(vehicleId: string): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-available-spare-parts/${vehicleId}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
  * Get vehicle transfer destinations
  * @returns Observable<ApiResponse>
  */
  fetchVehicleDestinations(): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/get-vehicle-destinations`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Release vehicle for transfer
   * @param vehicleId
   * @param chassisNo
   * @param selectedSpareParts
   * @param driverName
   * @param transferFrom
   * @param transferTo
   * @param transferReason
   * @param comment
   * @param userId
   * @returns
   */
  release(vehicleId: string, chassisNo: string, selectedSpareParts: any[],driverName:string,transferFrom:string, transferTo:string, transferReason:string, comment: string|null,userId:string): Observable<any> {

    let apiURL:string=`${this.baseURL}/v1/transfer-release-vehicle`;

    const data = {
      vehicle_id: vehicleId,
      chassis_no:chassisNo,
      selected_spare_parts: selectedSpareParts,
      driver_name:driverName,
      location_id:transferFrom,
      dest_branch_id:transferTo,
      transfer_reason:transferReason,
      comment:comment,
      user_id:userId
    };

    return this.http.post<any>(apiURL, data);
  }
}
